import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "w-25 rounded-lg border ms-3 my-3 p-3" }
const _hoisted_4 = { class: "d-none d-lg-inline" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paint-brush" }, null, -1)

import { onMounted, ref } from "vue";
import axios from "axios";
import { SessionUser } from "../../../utils/SessionUser";
import { AwsFile } from "../section/AwsFile";
import FileCardSection from "../section/FileCardSection.vue";
import PageNation from "../../../../framework/components/table/PageNation.vue";
import FileUploadSection from "../section/FileUploadSection.vue";
import { UserFileImpl } from "../../../utils/UserFile";
import { translation } from "../../../lang/Translation";
import FileFilterByTypeSection, { FilterFile } from "./FileFilterByTypeSection.vue";
import NewBadge from "../../../components/common/NewBadge.vue";
import { useRouter, useRoute } from 'vue-router';

/**
 * プロパティ
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'UserUploadedFilesSection',
  setup(__props) {

const list = ref([] as AwsFile[]);
const dispList = ref([] as AwsFile[]);
const dispSize = ref(12);
const currentPage = ref(1);
const t = translation;
const router = useRouter();
const route = useRoute();

/**
 * リストの取得
 */
const getList = async () => {
  // console.log('getList');

  // jsonを取得
  const user = SessionUser.instance;
  const url = new URL(location.href);
  url.pathname = `/webapi/file/filelist_api`;
  url.searchParams.append("user_id", `${user.userId}`);
  url.searchParams.append("token", `${user.token}`);

  const response = await axios.get<AwsFile[]>(url.href);
  let data = response.data;
  data = data.map((i) => {
    i.filePath = i.Key;
    return i;
  });
  list.value = data.sort((a, b) => {
    return b.LastModified > a.LastModified ? 1 : -1;
  });
};

onMounted(() => {
  getList().then();
});

const filterChanged = (filteredRows: FilterFile[], type: string) => {
  dispList.value = filteredRows as any;
};

// ページネイションの移動
const pageChanged = (rowInPage: any[], currentPageNew: number) => {
  currentPage.value = currentPageNew + 1;
  dispList.value = rowInPage;
};

const newFilePath = ref("");
const addNew = async (filePath: string) => {
  newFilePath.value = filePath;
  await getList();
};

// 言葉で絵を描く
const drawImage = ()=>{
  
  router.push({ name: "WordToCanvasAr" ,params:{project_id : route.params.project_id}});
}

return (_ctx: any,_cache: any) => {
  const _component_NoFilesInSection = _resolveComponent("NoFilesInSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t).to("マイアセット", "file_page_user")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FileUploadSection, {
        "on-upload": addNew,
        class: "w-75"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary btn-lg w-100 h-100",
          onClick: drawImage
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t).to("言葉で絵を描く","word_to_image")), 1),
          _hoisted_5,
          _createTextVNode(),
          _createVNode(NewBadge, { class: "d-none d-lg-inline" })
        ])
      ])
    ]),
    _createVNode(FileFilterByTypeSection, {
      lows: list.value,
      "on-filter-changed": filterChanged
    }, null, 8, ["lows"]),
    (dispList.value.length < 1)
      ? (_openBlock(), _createBlock(_component_NoFilesInSection, { key: 0 }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dispList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.Key,
        class: "col-lg-3 col-md-12"
      }, [
        _createVNode(FileCardSection, {
          item: _unref(UserFileImpl).instanceFromAwsFile(item),
          index: index,
          size: item.Size,
          "last-modified": item.LastModified,
          class: _normalizeClass({ added: newFilePath.value === item.Key }),
          "list-reload": getList
        }, null, 8, ["item", "index", "size", "last-modified", "class"])
      ]))
    }), 128)),
    _createVNode(PageNation, {
      class: "my-3",
      "full-rows": list.value,
      "page-size": dispSize.value,
      "on-page-changed": pageChanged
    }, null, 8, ["full-rows", "page-size"])
  ], 64))
}
}

})